import React, { ChangeEvent, useState } from "react";
import { Organization } from "../common/ObjectTypes";
import TextInput from "../common/TextInput";
import UnauthorizedResponse from "../../helpers/UnauthorizedResponse";
import { getCurrentUser } from "../../helpers/authHeader";

type AddEditOrgTypes = {
  organization: Organization;
  onCancelEdit: Function;
  onChange: Function;
  onSave: Function;
  onDelete: Function;
  existingOrg: boolean;
};

const AddEditOrg = ({
  organization,
  onChange,
  onSave,
  onCancelEdit,
  onDelete,
  existingOrg,
}: AddEditOrgTypes) => {
  const [subStr, setSubStr] = useState("");
  const currentUser = getCurrentUser();

  const isInUserOrganizations =
    currentUser?.organizations && organization?.organizationId
      ? currentUser.organizations.some(
          (org: any) => org.organizationId === organization.organizationId
        )
      : false;

  const isEnabled =
    currentUser.isSystemAdmin || isInUserOrganizations || existingOrg;

  if (!isEnabled) {
    return (
      <UnauthorizedResponse
        message="You don't have permission to edit this video. Only system administrators or users in the same organization can modify this content."
        redirectUrl="/"
      />
    );
  }

  return (
    <div className="w-full my-4">
      <form
        className="flex flex-col items-center"
        onSubmit={(e) => e.preventDefault()}
      >
        <h1 className="font-bold text-center text-4xl mb-6">
          {existingOrg ? "Edit Organization" : "Add Organization"}
        </h1>
        <div className="bg-grayScale-300 w-2/3">
          <div className="flex flex-col py-2">
            <div className="px-6">
              {/* name */}
              <div className="pb-2">
                <TextInput
                  name={"name"}
                  label={"Name"}
                  placeholder={""}
                  value={organization.name}
                  error={""}
                  disabled={false}
                  className={"bg-white-800 p-2 w-full rounded shadow"}
                  type={"text"}
                  initialFocus={true}
                  onChange={(e: any) => onChange(e)}
                />
                <div className="py-2 flex flex-row justify-end">
                  {/* <button
                    className="cursor-pointer p-2 rounded cursor-pointer"
                    onClick={() => onDelete()}
                  >
                    <DeleteIcon />
                  </button> */}{" "}
                  <button
                    type="button"
                    className="px-3 py-2 rounded bg-deepGreen-500 text-white hover:bg-deepGreen-700 drop-shadow-lg"
                    onClick={(e) => {
                      e.preventDefault();
                      onCancelEdit();
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="px-3 py-2 ml-2  rounded bg-deepGreen-500 text-white hover:bg-deepGreen-700 drop-shadow-lg"
                    onClick={(e) => {
                      e.preventDefault();
                      onSave();
                    }}
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default AddEditOrg;
